module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_0_1@3x.aa11dc84.png";